import { render, staticRenderFns } from "./UpdateAppsApp.vue?vue&type=template&id=0bb6c581&scoped=true&"
import script from "./UpdateAppsApp.vue?vue&type=script&lang=js&"
export * from "./UpdateAppsApp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAppsApp.vue?vue&type=style&index=0&id=0bb6c581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6c581",
  null
  
)

export default component.exports